import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Documento } from 'app/oDres/modelos/Empresa/documento';
import { AuthService } from 'app/shared/auth/auth.service';
import { FileUploader } from 'ng2-file-upload';
import { NgxSpinnerService } from 'ngx-spinner';
import swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { Usuario } from 'app/oDres/modelos/Empresa/usuarios';
import { GeneralesService } from 'app/shared/services/general.service';
const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';
@Component({
  selector: 'app-usuario-profile',
  templateUrl: './usuario-profile.component.html',
  styleUrls: ['./usuario-profile.component.scss']
})
export class UsuarioProfileComponent implements OnInit {

  currentDate : Date = new Date();
  closeResult: string;

  uploader: FileUploader = new FileUploader({
    url: URL,
    isHTML5: true
  });
  hasBaseDropZoneOver = false;
  hasAnotherDropZoneOver = false;

  croppedImage: any = '';

  showCropper = false;

  imageChangedEvent: any = '';

  fileName = '';

  documentoSubir: Documento = {} as Documento;

  canvasRotation = 0;
  transform: ImageTransform = {};
  rotation = 0;
  scale = 1;

  apretoGuardarContrasena = false;
  contrasenaActual = null;
  contrasenaNueva = null;
  contrasenaNuevaConfirmar = null;

  errorContrasena = false;
  errorContrasenaNueva = false;
  errorContrasenaNuevaCoincidencia = false;
  contrasenaCoincide = true;

  constructor(public authService: AuthService, private modalService: NgbModal, private spinner: NgxSpinnerService, 
    private generalesService: GeneralesService) { }

  ngOnInit(): void {
  }

  fileOverBase(e: any): void {
    // this.hasBaseDropZoneOver = e;
    this.imageChangedEvent = event;
  }

  fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  fileChangeEvent(event: any): void {
    this.fileName = event.target.files[0].name;
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = event.base64;
  }

  imageLoaded() {
    this.showCropper = true;
  }

  cropperReady() {
      // cropper ready
  }

  loadImageFailed() {
      // show message
  }

  cancelCropping() {
    this.imageChangedEvent = null;
    this.showCropper = false;
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
      this.canvasRotation++;
      this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
        ...this.transform,
        flipH: flippedV,
        flipV: flippedH
    };
  }

  flipHorizontal() {
    this.transform = {
        ...this.transform,
        flipH: !this.transform.flipH
    };
  }

  flipVertical() {
      this.transform = {
          ...this.transform,
          flipV: !this.transform.flipV
      };
  }

  updateRotation() {
    this.transform = {
        ...this.transform,
        rotate: this.rotation
    };
  }

  zoomOut() {
    this.scale -= .1;
    this.transform = {
        ...this.transform,
        scale: this.scale
    };
  }

  zoomIn() {
      this.scale += .1;
      this.transform = {
          ...this.transform,
          scale: this.scale
      };
  }  

  getFile(event: any){
    //console.log('file: ', event.target.files[0]);

    this.fileName = event.target.files[0].name;
    this.imageChangedEvent = event;
  }

  revisarRotation(){
    //console.log(this.rotation);

    if (this.rotation == undefined || this.rotation == null) {
      this.rotation = 0;
    }
  }

  zoomChange(){
      this.transform = {
          ...this.transform,
          scale: this.scale
      };
  }

  revisarZoom(){
    //console.log(this.scale);

    if (this.scale == undefined || this.scale == null) {
      this.scale = 1;
    }
  }

  editarAvatar(content) {

    this.modalService.open(content, {backdrop: 'static', windowClass:'editarAvatar', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      //console.log(this.closeResult);
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        //console.log(this.closeResult);
    });

  }

  guardarImagen() {

    this.spinner.show();

    this.documentoSubir = {
      nombreArchivo: 'imagenesavatar/' + this.authService.usuarioConectado.Usuario.IdUsuario  + '/' + this.fileName,
      contenedor: this.authService.usuarioConectado.Empresa.Identificador.toLocaleLowerCase().trim(),
      esImagen: true,
      archivo: this.croppedImage.replace('data:image/png;base64,', ''),
      IdUsuario: this.authService.usuarioConectado.Usuario.IdUsuario
    };

    this.generalesService.guardarAvatar(this.documentoSubir).subscribe((datos) => {

      //console.log(datos);

      if (datos != null && datos.code === 200) {

        this.imageChangedEvent = null;
        this.showCropper = false;

        this.authService.usuarioConectado.Usuario.Urlimagen = datos.model;
       
        this.spinner.hide();

        this.modalService.dismissAll();        

      } else {

        const opciones: SweetAlertOptions = {
          icon: 'error',
          title: 'Error',
          text: datos.message,
          type: 'error',
          allowOutsideClick: false,
          allowEscapeKey: false
        } as SweetAlertOptions;

        this.spinner.hide();

        swal.fire(opciones);

      }

    });

  }

  cambiarContrasena() {

    this.apretoGuardarContrasena = true;

    this.confirmarContrasena();

    if (!this.errorContrasena 
      && !this.errorContrasenaNueva
      && !this.errorContrasenaNuevaCoincidencia
      && this.contrasenaCoincide) {  

      this.spinner.show();

      // Primero revisar que la contraseña anterior si sea igual a la que tiene actualmente
      this.generalesService.obtenerUsuario({IdUsuario: this.authService.usuarioConectado.Usuario.IdUsuario} as Usuario).subscribe(usuarioRespuesta => {

        //console.log(usuarioRespuesta);

        if (usuarioRespuesta != null && usuarioRespuesta.code == 200) {

          this.generalesService.actualizarContrasenaUsuario({IdUsuario: this.authService.usuarioConectado.Usuario.IdUsuario, 
            contrasena: this.contrasenaActual,
            contrasenaNueva: this.contrasenaNueva} as Usuario).subscribe(usuarioActualizarRespuesta => {

            //console.log(usuarioActualizarRespuesta);
      
            if (usuarioActualizarRespuesta != null && usuarioActualizarRespuesta.code == 200){
      
              this.spinner.hide();

              this.contrasenaActual = null;
              this.contrasenaNueva = null;
              this.contrasenaNuevaConfirmar = null;
              this.apretoGuardarContrasena = false;

              this.modalService.dismissAll();
      
            } else {
      
              const opciones: SweetAlertOptions = {
                icon: 'error',
                title: 'Error',
                text: usuarioActualizarRespuesta.message,
                type: 'error',
                allowOutsideClick: false,
                allowEscapeKey: false
              } as SweetAlertOptions;
      
              this.spinner.hide();
      
              swal.fire(opciones);
      
            }
      
          });

        } else {
      
          const opciones: SweetAlertOptions = {
            icon: 'error',
            title: 'Error',
            text: usuarioRespuesta.message,
            type: 'error',
            allowOutsideClick: false,
            allowEscapeKey: false
          } as SweetAlertOptions;

          this.spinner.hide();

          swal.fire(opciones);

        }

      });

    }    
    
  }

  confirmarContrasena(){

    //console.log('confirmarContrasena');
    
    this.errorContrasena = false;
    this.errorContrasenaNuevaCoincidencia = false;

    if (this.apretoGuardarContrasena) {

      if ((this.contrasenaActual != null
        && this.contrasenaActual != undefined 
        && this.contrasenaActual.trim() != '')) {

          if ((this.contrasenaNueva != null
            && this.contrasenaNueva != undefined 
            && this.contrasenaNueva.trim() != '')) {
      
              if ((this.contrasenaNuevaConfirmar != null
                && this.contrasenaNuevaConfirmar != undefined 
                && this.contrasenaNuevaConfirmar.trim() != '')) {

                  this.errorContrasena = false;
                  this.errorContrasenaNueva = false;
                  this.errorContrasenaNuevaCoincidencia = false;          

                  if (this.contrasenaNueva.trim() 
                  == this.contrasenaNuevaConfirmar.trim())
                  {                                   
                    this.contrasenaCoincide = true;
                  } else {
                    this.contrasenaCoincide = false;
                  }

              } else {
                this.errorContrasenaNueva = false;
                this.errorContrasenaNuevaCoincidencia = true;
              }

          } else {
            this.errorContrasena = false;
            this.errorContrasenaNueva = true;

            if ((this.contrasenaNuevaConfirmar != null
              && this.contrasenaNuevaConfirmar != undefined 
              && this.contrasenaNuevaConfirmar.trim() != '')) { 
      
                this.errorContrasenaNuevaCoincidencia = false;
      
            } else {

              this.errorContrasenaNuevaCoincidencia = true;
            }

          }

      } else {

        if ((this.contrasenaNueva != null
          && this.contrasenaNueva != undefined 
          && this.contrasenaNueva.trim() != '')) { 

            this.errorContrasena = true;
            this.errorContrasenaNueva = false;

            if ((this.contrasenaNuevaConfirmar != null
              && this.contrasenaNuevaConfirmar != undefined 
              && this.contrasenaNuevaConfirmar.trim() != '')) { 
      
                this.errorContrasena = true;
                this.errorContrasenaNuevaCoincidencia = false;

            } else {

              this.errorContrasenaNuevaCoincidencia = true;

            }
        } else {

          if ((this.contrasenaNueva != null
            && this.contrasenaNueva != undefined 
            && this.contrasenaNueva.trim() != '')) { 

              this.errorContrasena = true;
              this.errorContrasenaNueva = true;
              this.errorContrasenaNuevaCoincidencia = false;

          } else {

            this.errorContrasena = false;
            this.errorContrasenaNueva = false;
            this.errorContrasenaNuevaCoincidencia = false;

          }

        }

        

      }

    }

  }

  editarInformacion(content) {

    this.modalService.open(content, {backdrop: 'static', windowClass: 'verInformacionUsuario', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      //console.log(this.closeResult);
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        //console.log(this.closeResult);
    });

  }

  cerrarModalUsuario(){
    this.contrasenaActual = null;
    this.contrasenaNueva = null;
    this.contrasenaNuevaConfirmar = null;
    this.apretoGuardarContrasena = false;
    this.modalService.dismissAll();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
    } else {
        return `with: ${reason}`;
    }
  }

}
